

import { Component, OnInit, ElementRef, ViewChild, ViewContainerRef} from '@angular/core';
import {ActivatedRoute, Router, Params } from '@angular/router';

import { MatSidenav, MatSnackBar } from '@angular/material';

import {map,debounceTime} from 'rxjs/operators';
import { CommonService } from '../../services/common.service';
import { CartService } from '../../services/cart.service';
import { MitterService } from '../../services/mitter.service';
import { AuthService } from '../../authentication/auth.service';
import { ProductsService } from '../../services/products.service';
import { Cartitems2 } from '../../classes/cartitems';
import {BehaviorSubject, Observable, Subject, Subscriber,pipe} from 'rxjs';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  pulsemenuflag: number;
  cartflag: number;
data= [];
invStock = [];
searchdata: any;
subtotal = 0;
stype: any;
searchterm: any;
msg: any;
action: any;
timer: any;
counter = 3;
menuflag: any;
nestmenuflag: any;
uid: any;
uname: any;
uemail: any;
umobile: any;
totalitems = 0;
data2: any;
userStatus: number;
loading: any;
userimg = 'avatar-1577909_960_720.png';
username = 'User';
userrole = 9;
imgpath: any = {};
lastorder = [];
orderitem: any;
ordercountflag: number;
cindex: any;
payable: number;
quantity: any;
pid: number;
tax: number;
totaldiscount: number;
discount: number;
prodprice: number
prodsku: any;
prodname: string;
cquantity = 0;
citems: number;
flag = 0;
  constructor(private router: Router, private cartService: CartService,
    private commonService: CommonService, private mitterService: MitterService,
 private authService: AuthService, public snackBar: MatSnackBar, private productService: ProductsService) {
  this.cartService.totalcartitems.subscribe(totalcartitems => {
    this.totalitems = totalcartitems;
     this.refreshcart();
  });
  this.timer = setInterval(() => this.timedelay(), 1000)
  }

  ngOnInit() {

    this.loading = true;
    this.commonService.getCategories()
    .subscribe(
      (x) => {
        this.data = x;
      }
    );
    this.getSearchdata();
  }
  timedelay() {
    this.counter = this.counter  - 1;
    if (this.counter === 0) {
      this.commonService.menuflag.subscribe(menuflag => {
        this.menuflag = menuflag ;
    });
    this.commonService.nestmenuflag.subscribe(nestmenuflag => {
      this.nestmenuflag = nestmenuflag ;
  });
    this.commonService.pulsemenuflag.subscribe(pulsemenuflag => {
      this.pulsemenuflag = pulsemenuflag ;
  });
     const udata = this.commonService.getUserDataLocally();
     this.uid = udata.uid;
     this.checkUserStatus();
     this.checkUserType();
     if (this.userStatus == 1) {
      this.cartService.getUserLastorder(this.uid)
      .subscribe(
        (x) => {
          if (x.length > 0) {
           this.lastorder.push(x[0]);
           this.getOrderItems(this.lastorder[0].orderno)
          }
        });
      }
      this.cartService.getUserCartItems(this.uid)
      .subscribe(
        (data2: Cartitems2[]) => {
          this.data2 = data2;
          this.setCartcount();
          this.getCartDetail();
        });


       this.loading = false;
     clearInterval(this.timer);
     }
    }
    refreshcart() {
      this.subtotal = 0;
      this.data2 = [];
      this.imgpath = [];
      this.cartService.getUserCartItems(this.uid)
      .subscribe(
        (x) => {
          this.data2 = x;
          this.getCartDetail();
          for (let i = 0; i < this.data2.length; i++) {
            this.subtotal = this.subtotal + this.data2[i].payable
          }
        });
    }
    getCartDetail() {
      if ( this.data2.length > 0 ) {
        for ( let i = 0 ; i < this.data2.length; i++) {
          this.getimg(this.data2[i].sku);
        }
      }
    }
    getimg(sku) {
      this.productService.getProductimagebySku(sku)
      .subscribe(
        (x) => {
          this.imgpath['id' + x[0].sku] = x[0].image;
        }
        );
    }
    checkUserStatus() {
      this.userStatus = this.commonService.checkUserStatus();
      if (this.userStatus == 1) {
        const udata = this.commonService.getUserDataLocally();
        this.uid = udata.uid;
        this.uname = udata .uname;
        this.uemail = udata.uemail;
        this.umobile = udata.umobile;
        this.username = this.uname;
      this.cartService.getUserData(this.uemail)
      .subscribe(
        (x) => {
          this.userimg = x[0].image;
        });
      }
    }
    checkUserType() {
     this.userrole = this.authService.getRoleId();
  }
  setCartcount() {
    let count = 0;
    this.subtotal = 0;
    for (let i = 0; i < this.data2.length; i++) {
      count = count + this.data2[i].quantity;
      this.subtotal = this.subtotal + this.data2[i].payable
    }
    this.cartService.changeTotalCartItems(count);
    //this.reflect();
  }
  login() {
    this.router.navigate(['/signin']);
  }
  logout() {
    const flag = 0;
    this.commonService.setActivatepath(flag);
    this.mitterService.logout();
    this.authService.logout();
    this.commonService.setuserStatus();
    this.router.navigate(['/signin']);
  }
  reflect() {
    this.cartService.totalcartitems.subscribe(totalcartitems => {
      this.totalitems = totalcartitems;
    });
  }
  goToCart() {
    this.router.navigate(['/store/cart']);
  }
  getSearchdata() {
    this.commonService.getSearchdata()
    .subscribe (
      (x) => {
        this.searchdata = x;
      });
  }
  goToSearch() {
    if (this.stype === 'product' && this.searchterm !== undefined) {
      this.router.navigate(['/store/search/', 'product', this.searchterm ]);
    }
    if (this.searchterm === undefined) {
      this.msg = 'please type something to search';
      this.openSnackBar();
    }
  }
  checkEveryMatch(str, element) {
    if ( str.toString().toLowerCase().match(element)) {
      return 1;
    }else {
      return 0;
    }
  }
  


     goToDetail(type_id, url, type) {
      if (type === 'product') {
        this.router.navigate(['/store/details/', type_id , url]);
      } else if (type === 'doctor') {
        this.router.navigate(['/pulse/doctordetail/', type_id]);
      }
    }
    openSnackBar() {
      this.snackBar.open(this.msg , this.action, {
        duration: 4000,
      });
    }
 finalCheck () {
    this.loading = true;
    this.cartflag = 0;
    this.invStock = [];
    this.getinvstatus();
}
getinvstatus() {
  let cartlencount = this.data2.length;
  for ( let i = 0 ; i < this.data2.length; i ++) {
    this.commonService.getInventoryDetail(this.data2[i].product_id)
    .subscribe(
      (x) => {
        this.invStock.push(x[0]);
        cartlencount = cartlencount - 1;
        if (cartlencount === 0) {
          this.checkposibility();
        }
      });
  }
}

checkposibility() {
for (let j = 0 ; j < this.data2.length ; j++) {
  for (let i = 0 ; i < this.invStock.length ; i++) {
   if (this.data2[j].product_id === this.invStock [i] .product_id
  && (this.data2[j].quantity > this.invStock[i]. totalstock || this.invStock[i].status === 0)) {
    this.cartflag = this.cartflag + 1;
  }
}
}
this.loading = false;
if (this.cartflag === 0) {
  const flag = 2;
  this.commonService.setActivatepath(flag);
 this.router.navigate(['/store/checkout']);
}else {
  this.router.navigate(['/store/cart']);
 this.msg = 'We Have some Limited Stock For your item. So please modify your cart and try again';
 this.openSnackBar();
}
}
  getOrderItems(ono) {
    this.cartService.getOrderDetail(ono)
    .subscribe(
      (x) => {
        this.orderitem = x;
        this.ordercountflag = this.orderitem.length;
      });
  }
  goForReorder(orderno) {
  this.loading = true;
    this.cquantity = 0;
    this.ordercountflag = this.orderitem.length;
    this.addToCartFromOrderItems();
  }

  addToCartFromOrderItems() {
    for (let i = 0; i < this.orderitem.length; i++) {
      this.productService.getOrderitems(this.orderitem[i].sku, this.orderitem[i].product_name)
      .subscribe((x) => {
        this.addcart(this.orderitem[i].product_name, this.orderitem[i].sku,
          x[i].price, this.orderitem[i].product_id, this.orderitem[i].quantity, x[i].splprice);
      });

    }
  }
  addcart(name: string, sku: string, price: number, id: number, qty, splprice) {
    this.pid = id;
    this.prodname = name;
    this.prodsku = sku;
    this.prodprice = price;
   // this.discount = 0;
   // this.totaldiscount = 0;
   if (splprice === 0) {
    this.discount = 0;
    this.totaldiscount = 0;
    this.payable = price;
  }else {
    this.discount =  price - splprice;
    this.totaldiscount = splprice;
    this.payable = splprice;
  }
    this.checkItems(this.prodsku);
    this.tax = 0 ;
    if (this.flag === 0) {
      this.quantity = qty;
      this.cquantity = this.cquantity + qty;
     // this.payable = price * this.quantity;
     this.payable = this.payable * this.quantity;
      this.cartService.createCart(this.pid, this.prodname, this.prodsku, this.prodprice,
        this.discount, this.totaldiscount, this.quantity, this.payable, this.tax, this.uid, this.uname)
      .subscribe(
        (x: Cartitems2[]) => {
          this.ordercountflag = this.ordercountflag - 1;
          this.checkAllFlags();
        });
    } else {
      this.quantity = this.data2[this.cindex].quantity + qty;
      this.cquantity = this.cquantity + qty;
      this.payable = (this.data2[this.cindex].mrp - this.data2[this.cindex].discount) * this.quantity;
      this.cartService.updateCartIfPresent(this.data2[this.cindex].id, this.quantity, this.payable)
      .subscribe(
        (x: Cartitems2[]) => {
          this.ordercountflag = this.ordercountflag - 1;
          this.checkAllFlags();
        });
  }
  }
  checkAllFlags() {
    if (this.ordercountflag === 0) {
      this.loading = false;
      this.test();
    }
  }
  checkItems(sku) {
    this.flag = 0;
        if (this.data2.length > 0) {
          for (let i = 0; i < this.data2.length; i++) {
            if (this.data2[i].sku === sku) {
              this.flag = 1;
              this.cindex = i;
            }
          }
        } else {
          this.flag = 0;
        }
    }
  test() {
    this.cartService.totalcartitems.subscribe(totalcartitems => {
      this.citems = totalcartitems;
    });
    this.cartitemchange();
    this.msg = 'Items Added To Cart';
    this.openSnackBar();
   }
   cartitemchange() {
    this.citems = this.citems + this.cquantity;
   this.cartService.changeTotalCartItems(this.citems);
   this.goToCart();
  }

}
